// Unique content for dedicated, SEO-optimised service pages.
// Only verified Dentcraft NSW business information is used. No invented
// reviews, ratings, statistics or qualifications.

export const servicePages = {
  "hail-damage-repair-sydney": {
    slug: "hail-damage-repair-sydney",
    seoTitle: "Hail Damage Repair Sydney | Paintless Dent Removal | Dentcraft NSW",
    seoDescription:
      "Mobile hail damage repair across Sydney and Western Sydney. Dentcraft NSW uses paintless dent removal to restore hail-dented roofs, bonnets and boots without repainting. Free quote.",
    h1: "Hail Damage Repair Sydney",
    crumb: "Hail Damage Repair",
    heroImage:
      "https://images.unsplash.com/photo-1561138814-a1f83c5f4ac7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    heroAlt: "Car bonnet with hail damage being repaired in Sydney",
    intro: {
      eyebrow: "Hail Damage Repair Sydney",
      heading: "Storm-damaged car? We restore hail dents across Sydney",
      paragraphs: [
        "A single hail storm can leave dozens \u2014 sometimes hundreds \u2014 of small dents across your roof, bonnet and boot. Dentcraft NSW specialises in hail damage repair in Sydney using paintless dent removal (PDR), gently working each dent back to shape while keeping your original factory paint.",
        "Because we're fully mobile, we bring hail damage repair to your home or workplace right across Western Sydney and the wider Sydney Metro area, so you don't have to leave your car at a body shop for days.",
      ],
      bullets: [
        "Roof, bonnet, boot and panel hail dents",
        "Keeps your factory paint \u2014 no respray needed",
        "Mobile service across Sydney and Western Sydney",
        "Great alternative to costly conventional repairs",
      ],
      image:
        "https://images.unsplash.com/photo-1780586585338-c56fe47b49f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      imageAlt: "Hail-damaged car bonnet restored with paintless dent removal in Sydney",
    },
    features: [
      { icon: "CloudHail", title: "Hail Dent Specialists", text: "Experienced with large hail events \u2014 we assess and repair every affected panel methodically." },
      { icon: "Paintbrush", title: "Factory Paint Kept", text: "PDR massages dents from behind the panel, so there's no filler, sanding or repainting." },
      { icon: "MapPin", title: "Mobile Across Sydney", text: "We come to you throughout Western Sydney and Sydney Metro \u2014 Canterbury, Liverpool, Blacktown and Penrith." },
      { icon: "ShieldCheck", title: "Insurance Friendly", text: "PDR is widely recommended by insurers and can help keep your repair costs down." },
    ],
    faqs: [
      { q: "Can paintless dent removal fix hail damage in Sydney?", a: "Yes. Paintless dent removal is one of the most effective ways to repair hail damage, as long as the paint isn't cracked. It restores the panel while keeping your original factory finish." },
      { q: "Do you come to me for hail damage repair?", a: "We're a fully mobile service and travel across Western Sydney and Sydney Metro to repair hail-damaged vehicles at your home or workplace." },
      { q: "How do I get a quote for hail damage?", a: "Take a few photos of the damage and text them to Sam on 0474 020 202, or use our contact form, for an on-the-spot estimate." },
    ],
  },

  "door-ding-repair-sydney": {
    slug: "door-ding-repair-sydney",
    seoTitle: "Car Dent & Door Ding Repair Sydney | Dentcraft NSW",
    seoDescription:
      "Fast car dent and door ding repair in Sydney and Western Sydney. Dentcraft NSW removes car park dings, shopping trolley dents and minor creases with mobile paintless dent removal.",
    h1: "Car Dent & Door Ding Repair Sydney",
    crumb: "Door Ding Repair",
    heroImage:
      "https://images.unsplash.com/photo-1564705604144-51593412c133?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    heroAlt: "Car door with a small door ding before dent repair in Sydney",
    intro: {
      eyebrow: "Car Dent Repair Sydney",
      heading: "Door dings and car park dents removed \u2014 quickly",
      paragraphs: [
        "Door dings from car parks, shopping trolleys and stray footballs are the most common dents we see. Dentcraft NSW provides car dent repair in Sydney using paintless dent removal, so small dents and creases disappear without any repainting or filler.",
        "Most door dings take only minutes to hours rather than days, and because we're mobile, we can remove them at your home or workplace right across Western Sydney and Sydney Metro.",
      ],
      bullets: [
        "Car park door dings and trolley dents",
        "Minor creases and pressure dents",
        "Same original paint, no colour matching",
        "Fast turnaround, mobile across Sydney",
      ],
      image:
        "https://images.unsplash.com/photo-1705443990676-c94a1005898c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      imageAlt: "Door ding on a car panel repaired with paintless dent removal in Sydney",
    },
    features: [
      { icon: "BadgeCheck", title: "Invisible Repairs", text: "Done well, a repaired door ding is impossible to spot \u2014 the panel looks factory again." },
      { icon: "Timer", title: "Fast Turnaround", text: "Most small dings are repaired in minutes to hours, not days in a body shop." },
      { icon: "PiggyBank", title: "Affordable", text: "PDR costs a fraction of traditional panel beating and paint for the same small dents." },
      { icon: "MapPin", title: "We Come To You", text: "Mobile door ding repair across Western Sydney and Sydney Metro at your home or work." },
    ],
    faqs: [
      { q: "How much does door ding repair cost in Sydney?", a: "It depends on the size, depth and location of the dent. Send a photo to Sam on 0474 020 202 for a free, on-the-spot estimate." },
      { q: "Will the paint match after a door ding repair?", a: "Yes \u2014 paintless dent removal keeps your original factory paint, so there's nothing to colour match or respray." },
      { q: "Can you repair multiple dents at once?", a: "Absolutely. We can assess and repair several door dings or dents in the same visit across your vehicle." },
    ],
  },

  "mobile-dent-repair-sydney": {
    slug: "mobile-dent-repair-sydney",
    seoTitle: "Mobile Dent Repair Sydney & Western Sydney | Dentcraft NSW",
    seoDescription:
      "Mobile dent repair in Sydney and Western Sydney. Dentcraft NSW brings paintless dent removal to your home or workplace for door dings, dents and hail damage. Free on-the-spot quotes.",
    h1: "Mobile Dent Repair Sydney",
    crumb: "Mobile Dent Repair",
    heroImage:
      "https://images.pexels.com/photos/20131971/pexels-photo-20131971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600",
    heroAlt: "Mobile paintless dent removal technician repairing a car in Sydney",
    intro: {
      eyebrow: "Mobile Dent Repair Sydney",
      heading: "We bring the dent repair workshop to you",
      paragraphs: [
        "Dentcraft NSW is a fully mobile dent repair service. Instead of dropping your car at a workshop, we come to your home or workplace across Sydney and Western Sydney and complete the paintless dent removal on-site.",
        "From single door dings to hail damage across multiple panels, our mobile PDR service covers Sydney Metro suburbs including Canterbury, Liverpool, Blacktown and Penrith \u2014 for cars, trucks and motorbikes.",
      ],
      bullets: [
        "On-site repairs at your home or workplace",
        "Covers Western Sydney and Sydney Metro",
        "Cars, trucks and motorbikes welcome",
        "On-the-spot estimates over the phone",
      ],
      image:
        "https://images.unsplash.com/photo-1604447199408-9798f9f64f88?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      imageAlt: "Mobile dent repair being carried out on a car in Western Sydney",
    },
    features: [
      { icon: "MapPin", title: "Fully Mobile", text: "We travel to you across Western Sydney and Sydney Metro \u2014 no need to visit a workshop." },
      { icon: "Smartphone", title: "Easy Quotes", text: "Text a photo of the damage to Sam and get an on-the-spot estimate the same day." },
      { icon: "Clock", title: "Same-Day Service", text: "Many mobile repairs can be completed the same day, around your schedule." },
      { icon: "BadgeCheck", title: "Careful & Professional", text: "Every vehicle \u2014 from daily drivers to prestige cars \u2014 is treated with meticulous care." },
    ],
    faqs: [
      { q: "What areas do you cover for mobile dent repair?", a: "We cover Sydney and Western Sydney, including Sydney Metro suburbs such as Canterbury, Liverpool, Blacktown and Penrith." },
      { q: "Do you repair dents at my workplace?", a: "Yes. As a mobile service we can come to your home or workplace and complete the repair on-site." },
      { q: "What types of vehicles do you repair?", a: "We repair cars, trucks and motorbikes \u2014 from everyday vehicles to prestige and classic cars." },
    ],
  },
};

export const serviceLinks = [
  { label: "Paintless Dent Removal", path: "/paintless-dent-removal" },
  { label: "Hail Damage Repair Sydney", path: "/hail-damage-repair-sydney" },
  { label: "Door Ding Repair Sydney", path: "/door-ding-repair-sydney" },
  { label: "Mobile Dent Repair Sydney", path: "/mobile-dent-repair-sydney" },
];
